import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import { useAuth } from '../contexts/AuthContext';

export default function InviteAcceptPage() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const { user, loading, refresh } = useAuth();
  const navigate = useNavigate();
  const [state, setState] = useState({ status: 'idle', text: '' });

  useEffect(() => {
    if (loading) return;
    if (!token) { setState({ status: 'err', text: '초대 토큰이 없습니다.' }); return; }
    if (!user) { setState({ status: 'need-login', text: '초대를 수락하려면 먼저 로그인하세요.' }); return; }

    let done = false;
    (async () => {
      setState({ status: 'working', text: '초대 수락 중…' });
      const { data, error } = await supabase.rpc('accept_invitation', { invite_token: token });
      if (done) return;
      if (error) { setState({ status: 'err', text: '오류: ' + error.message }); return; }
      if (data?.ok) {
        await refresh();
        setState({ status: 'ok', text: '초대를 수락했습니다. 워크스페이스로 이동합니다…' });
        setTimeout(() => navigate('/', { replace: true }), 1200);
      } else {
        setState({ status: 'err', text: data?.error || '초대를 수락할 수 없습니다.' });
      }
    })();
    return () => { done = true; };
  }, [token, user, loading, navigate, refresh]);

  return (
    <div className="center">
      <div className="auth-box">
        <div className="auth-logo">루</div>
        <h2>초대 수락</h2>
        <div className="sub">루나르트 워크스페이스</div>

        {state.status === 'working' && <div className="center" style={{ minHeight: 0 }}><div className="spinner" /></div>}
        {state.status === 'ok' && <div className="note ok">{state.text}</div>}
        {state.status === 'err' && <div className="note err">{state.text}</div>}
        {state.status === 'need-login' && (
          <>
            <div className="note info">{state.text}</div>
            <Link className="btn" style={{ marginTop: 12, textDecoration: 'none' }}
              to={`/login`}>로그인하러 가기</Link>
          </>
        )}
      </div>
    </div>
  );
}
